import { Email, Link as LinkIcon, Location, People, Technology } from '@/components/Svg';
import t from '@/lib/localization';
import { ActionIcon, Card, createStyles, Grid } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

const useStyles = createStyles((theme) => ({
  para: {
    fontSize: '14px',
    lineHeight: '24px',
  },
}));

export default function OrganizationCard({ organization, dictionary, ...props }) {
  const router = useRouter();
  const { classes } = useStyles();
  return (
    <Card
      padding="lg"
      style={{
        borderRadius: '12px',
      }}
      withBorder
      className={`${props.className} card-hover`}
    >
      <Grid align="center">
        <Grid.Col span={6}>
          <div className="flex items-center">
            <Link
              href={`/organizations/${organization.slug ? organization.slug : organization.id}`}
              className="no-underline "
            >
              <Image
                height={50}
                width={50}
                className="rounded-full hover:cursor-pointer"
                onClick={() =>
                  router.push(
                    `organizations/${organization.slug ? organization.slug : organization.id}`
                  )
                }
                radius="xl"
                src={organization.photoURL ?? '/images/user.svg'}
                alt={organization.name}
              />
            </Link>
            <div className="flex flex-col ms-4">
              <Link
                href={`/organizations/${organization.slug ? organization.slug : organization.id}`}
                className="no-underline "
              >
                <h4
                  className={`${classes.title} font-semibold text-lg text-grayCustom hover:cursor-pointer  hover:text-primary m-0 transition-all duration-200 whitespace-nowrap truncate max-w-[200px]`}
                >
                  {organization.name}
                </h4>
              </Link>
              <div className="flex items-center text-textGrey">
                <Location />
                <p className="p-0 m-0 ms-2 text-textGrey text-[14px] whitespace-nowrap ">
                  {organization.location}
                </p>
              </div>
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={4}>
          <div className="flex flex-col justify-center">
            <div className="flex items-center text-primary">
              <Technology width="18" />
              <p className={`${classes.para} text-textGrey ms-2 m-0 whitespace-nowrap `}>
                {organization.type}
              </p>
            </div>
            <div className="flex items-center mt-[10px] text-primary">
              <People width="18" />
              <p className={`${classes.para} text-textGrey ms-2 m-0 whitespace-nowrap `}>
                {t(dictionary.countEmployees, { count: organization.size })}
              </p>
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={2}>
          <div className="flex gap-2">
            <Link href={`tel:${organization.phoneNo}`} aria-label="Call">
              <ActionIcon
                className="text-primary border-solid border-primary rounded-full h-[32px] w-[32px] hover:bg-primary hover:text-white transaton ease-in duration-200"
                aria-label="Call"
              >
                <LinkIcon height="15px" width="15px" />
              </ActionIcon>
            </Link>
            <Link href={`mailto:${organization.businessEmail}`} aria-label="Email">
              <ActionIcon
                className="text-primary border-solid border-primary rounded-full h-[32px] w-[32px] ms-[7px] hover:bg-primary hover:text-white transaton ease-in duration-200"
                aria-label="Email"
              >
                <Email width="15px" height="11px" />
              </ActionIcon>
            </Link>
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
